import React from "react";
import { ADDONS } from "../../data/content";

const ADDON_CATS = [{ k: "exterior", label: "Exterior" }, { k: "interior", label: "Interior" }, { k: "signature", label: "Signature" }];

export default function AddonsFeesStep({
  fees, setFees, setDistance, distance, checking, checkAddress,
  addonSize, jobMinutes, addonSel, toggleAddon, setTier, addonSubtotal, freeAddons,
}) {
  return (
    <div>
      <h1 className="text-3xl font-extrabold tracking-tight">Add-ons & fees</h1>
      <p className="text-zinc-400 mt-2">Firm add-on prices based on your vehicle size. Pick a severity where it applies — everything's added to your total.</p>
      <div className="mt-5 flex gap-2">
        <input value={fees.address} onChange={(e) => { setFees({ ...fees, address: e.target.value }); setDistance(null); }} placeholder="Service address *" className="flex-1 bg-[#050505] border border-white/20 focus:border-pink-500 rounded-lg px-4 py-3 outline-none" data-testid="book-address" />
        <button onClick={checkAddress} disabled={checking} className="bg-white/10 hover:bg-pink-600 border border-white/15 rounded-lg px-4 py-3 text-sm font-semibold transition-colors disabled:opacity-50 whitespace-nowrap" data-testid="book-check-address">{checking ? "Checking…" : "Check travel"}</button>
      </div>
      {distance && (
        <div className={`mt-3 rounded-xl border p-4 text-sm ${distance.come_to_shop ? "border-amber-500/40 bg-amber-500/10 text-amber-200" : distance.fee > 0 ? "border-pink-500/40 bg-pink-500/10 text-pink-200" : "border-green-500/40 bg-green-500/10 text-green-200"}`} data-testid="distance-result">{distance.message}</div>
      )}
      {!distance && (
        <p className="mt-2 text-xs text-amber-400" data-testid="address-gate-hint">Enter your service address and tap "Check travel" to continue.</p>
      )}
      {distance && !distance.resolved && (
        <p className="mt-2 text-xs text-amber-400" data-testid="address-review-hint">We couldn't auto-verify this address, but you can still book — we'll confirm travel details before your appointment.</p>
      )}
      <div className="mt-4 space-y-2">
        {distance && distance.fee > 0 && !distance.come_to_shop && (
          <div className="flex items-center justify-between rounded-xl border border-pink-500/40 bg-[#1a1013] p-4"><span className="font-semibold">Outside-windward travel fee</span><span className="font-bold text-pink-500">+$20</span></div>
        )}
        <label className="flex items-center justify-between rounded-xl border border-white/10 bg-[#121212] p-4 cursor-pointer">
          <span><span className="font-semibold">Disaster Detail</span><span className="text-sm text-zinc-500 block">+$100 for interiors in disastrous condition</span></span>
          <input type="checkbox" checked={fees.disaster} onChange={(e) => setFees({ ...fees, disaster: e.target.checked })} data-testid="fee-disaster" />
        </label>
      </div>

      <div className="mt-6">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-zinc-300">Add-ons <span className="text-zinc-500">({addonSize === "suv" ? "3-row SUV / Truck" : "Sedan"} pricing)</span></p>
          <p className="text-xs text-zinc-500" data-testid="job-time">Est. job time: {jobMinutes} min</p>
        </div>
        {ADDON_CATS.map((cat) => (
          <div key={cat.k} className="mt-4">
            <p className="text-xs uppercase tracking-widest text-pink-500 font-bold mb-2">{cat.label}</p>
            <div className="grid gap-2 sm:grid-cols-2">
              {ADDONS.filter((a) => a.cat === cat.k).map((a) => {
                const sel = a.key in addonSel;
                const tierIdx = sel ? addonSel[a.key] : 0;
                const price = a.tiers[tierIdx][addonSize];
                return (
                  <div key={a.key} className={`rounded-xl border p-3 transition-all ${sel ? "border-pink-500 bg-[#1a1013]" : "border-white/10 bg-[#121212]"}`} data-testid={`addon-${a.key}`}>
                    <button onClick={() => toggleAddon(a.key)} className="w-full text-left flex items-center justify-between gap-2" data-testid={`addon-toggle-${a.key}`}>
                      <span className="text-sm font-semibold">{a.name}</span>
                      <span className="text-sm font-bold text-pink-500 whitespace-nowrap">${price}</span>
                    </button>
                    {sel && a.tiers.length > 1 && (
                      <div className="mt-2 flex flex-wrap gap-1.5">
                        {a.tiers.map((t, ti) => (
                          <button key={ti} onClick={() => setTier(a.key, ti)} className={`text-xs rounded-full px-2.5 py-1 ${tierIdx === ti ? "bg-pink-600" : "bg-white/5 border border-white/15"}`} data-testid={`addon-${a.key}-tier-${ti}`}>{t.label} ${t[addonSize]}</button>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        {addonSubtotal > 0 && <p className="mt-4 text-sm font-semibold" data-testid="addon-subtotal">Add-ons subtotal: <span className="text-pink-500">${addonSubtotal.toFixed(2)}</span></p>}
        {freeAddons.length > 0 && <p className="mt-1 text-xs text-green-400" data-testid="free-addons">Free: {freeAddons.join(", ")}</p>}
      </div>
    </div>
  );
}
